<div class="my-5">
  <sm-page-header [breadcrumb]="breadcrumb" title="fundingSources.title"> </sm-page-header>
  <!-- content -->
  <div class="content">
    <sm-data-table-builder
      [dataTableObject]="dataTableObject"
      [datas]="data"
      [loading]="loading"
      [totalRecords]="totalRecords"></sm-data-table-builder>
  </div>
  <sm-drawer #drawer [drawer]="fundingSourceDrawer"></sm-drawer>
  <sm-dialog #dialog [dialog]="fundingSourceDialog"></sm-dialog>
</div>
